import { createContext } from "react";

export const ImgContext = createContext();
export const ToastContext = createContext();
export const CreditsContext = createContext();